import isEqual from 'lodash-es/isEqual';

export const getQueryParams = (url: string): Record<string, string> => {
  url = url.replaceAll('amp;', '');
  url = url.replaceAll(';', '&');
  const queryParams = {};
  const params = url.split('?')[1]?.split('&');

  if (params) {
    params.forEach((p) => {
      const pp = p.split('=');
      queryParams[pp[0]] = pp[1];
    });
  }

  return queryParams;
};

export const compareQueryParams = (
  q1: Record<string, string>,
  q2: Record<string, string>
): boolean => {
  return isEqual(q1, q2);
};

export const escapeRegExp = (text: string): string => {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

export const replaceSrcset = (srcset: string, newImageSrc: string): string => {
  const newSrcset = [];

  srcset.split(',').forEach((src) => {
    const spiltSrc = src.trim().split(' ');

    spiltSrc[0] = spiltSrc[0].includes('data:image/') ? '' : newImageSrc;
    if (spiltSrc[0]) {
      newSrcset.push(spiltSrc.join(' '));
    }
  });

  return newSrcset.join(',');
};

export const containsValue = (str: string, value: string): boolean => {
  // Consider replacing includes with a REGExp that is more accurate
  // now we may generate mistakes
  return str && value && str.toLowerCase().includes(value.toLowerCase());
};

export const getTranslateXY = (
  element: HTMLElement
): { x: number; y: number } => {
  const style = window.getComputedStyle(element);
  const matrix = new DOMMatrixReadOnly(style.transform);
  return {
    x: matrix.m41,
    y: matrix.m42,
  };
};
